import { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import MainIndex from "./components/app/mainIndex";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AmazonApiUse from "./pages/AmazonApiUse";
import LandingFbAd from "./pages/LandingFbAd";
import CookieBanner from "./components/core/CookieBanner";
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import 'aos/dist/aos.css';

function MetaPixelPageView() {
  const location = useLocation();
  const prevPathRef = useRef(null);
  useEffect(() => {
    if (prevPathRef.current !== null && prevPathRef.current !== location.pathname) {
      trackPageView();
    }
    prevPathRef.current = location.pathname;
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <MetaPixelPageView />
          <Routes>
            <Route path="/" element={<MainIndex />} />
            <Route path="/lp/facebook" element={<LandingFbAd />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/amazon-api-use" element={<AmazonApiUse />} />
          </Routes>
          
          {/* Cookie consent banner - appears on all pages */}
          <CookieBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
